// Modules
import React from "react";
import PropTypes from "prop-types";

const HouseCheckmark = (props) => {
	const { clssName } = props;

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 70 70"
			className={clssName}
			style={{ enableBackground: "new 0 0 70 70" }}
		>
			<g>
				<polygon
					fill="#F7B67B"
					points="52.8,37.3 52.8,66.9 3.8,66.9 3.8,28.1 28.2,3.8 50.2,25.8 51.4,24.7 28.2,1.5 2.2,27.4 2.2,68.5 54.4,68.5 54.4,35.7"
				/>
				<g>
					<polygon
						fill="#0A313E"
						points="62.3,15.4 52.2,25.5 51,26.6 29.3,48.3 14.7,33.7 9.3,39.2 29.3,59.3 52.8,35.8 54.4,34.2 67.8,20.8"
					/>
				</g>
			</g>
		</svg>
	);
};

HouseCheckmark.propTypes = {
	clssName: PropTypes.string,
};

HouseCheckmark.defaultProps = {
	clssName: "",
};

export default HouseCheckmark;
